__turbopack_context__.v({
  "sectionButton": "xVpsyG_sectionButton",
  "sectionTabs": "xVpsyG_sectionTabs",
  "tabsContainer": "xVpsyG_tabsContainer",
  "tabsContainerVertical": "xVpsyG_tabsContainerVertical",
});
